import geocoderConfig from '#/geocoder-config';
import { SERVICE_STATE } from '#/shared/constants';

const { rect } = geocoderConfig.boundary;
function withinServiceArea(lat, lon, state = SERVICE_STATE) {
  let result;
  const { minLat, maxLat, minLon, maxLon } = rect;
  if (state !== SERVICE_STATE) {
    result = false;
  } else {
    result = lat >= minLat && lat <= maxLat && lon >= minLon && lon <= maxLon;
  }
  return result;
}

export default withinServiceArea;
